import Theme from '~/themes/theme.class'
import DefaultTheme from '~/themes/default'

export default class AppealTheme extends Theme {
  constructor () {
    super()

    const defaultTheme = new DefaultTheme()

    this.components = {
      homepage: {
        hero: () => import('~/modules/homepage/components/hero'),
      },
      layout: {
        subheader: {
          logo: () => import('~/components/frontend/layout/sub-header/care-logo'),
        },
      },
      myAccount: {
        popup: () => import('~/themes/referrals/components/my-account/popup'),
      },
    }

    /**
     * This segment keys its components by route name, so be aware of that!
     */
    this.marketing = {
      'cms:article': {
        aside: [
          () => import('~/modules/marketing/components/frontend/referrals/referrals-aside-box'),
        ],
      },
      'users:frontend:edit-details': {
        aside: [
          () => import('~/modules/marketing/components/frontend/referrals/referrals-aside-box'),
        ],
      },
      'users:frontend:edit-profile': {
        aside: [
          () => import('~/modules/marketing/components/frontend/referrals/referrals-aside-box'),
        ],
      },
      'users:frontend:edit-settings': {
        aside: [
          () => import('~/modules/marketing/components/frontend/referrals/referrals-aside-box'),
        ],
      },
    }
  }
}
